// 发布内容
<template>
  <div>
    <div class="contentList" style="position: relative">
      <el-empty :image="emptyImg" v-if="releasePageList.length <= 0"></el-empty>
      <template v-for="(v, i) in releasePageList">
        <div :key="i">
          <div class="flex-col group_11">
            <img
              v-if="v.isDeleted"
              class="judImg"
              src="../../assets/images/isdelete.png"
              alt=""
            />

            <div class="flex-col">
              <div class="publish-content">
                <img
                  class="avaImg"
                  src="../../assets/images/backimg3.png"
                  alt=""
                />
                <div
                  class="justify-between group_15 view_5"
                  style="flex-direction: column"
                >
                  <span class="text_46 text_18">{{ v.userName }} </span>
                  <div class="flex-row" style="margin-top: 10px">
                    <!-- <img :src="apiUrl + v.imageUrl" class="image_7" /> -->
                    <span class="text_48">{{ v.creationTime }}</span>
                    <span class="text_46">
                      发布于<i style="color: #2e9bff; font-size: 0.14rem">{{
                        v.type
                      }}</i></span
                    >
                  </div>
                </div>
              </div>

              <div class="text_39">
                <span class="titleIsDel">{{ v.title }}</span>
                <i v-if="v.isDeleted" @click="learnMore">查看内容</i>
              </div>

              <div
                class="group_13"
                v-if="(v.isDeleted && showDetials) || !v.isDeleted"
              >
                <span class="text_44">
                  {{ v.content }}
                </span>
                <br />
                <div class="imgs" v-if="v.imgUrl.length">
                  <img
                    v-for="(v, i) in v.imgUrl.split(',')"
                    :key="i"
                    :src="apiUrl + v"
                    alt=""
                    class="thumImg"
                    @click="seeDetials(v)"
                  />
                </div>
              </div>
              <div
                class="flex-row list view_3"
                v-if="v.sysSignStrArr.length > 0 && showDetials"
              >
                <div
                  class="flex-col items-center text-wrapper_2"
                  :key="i"
                  v-for="(item, i) in v.sysSignStrArr"
                >
                  <span class="text_40">{{ item }}</span>
                </div>
              </div>
            </div>

            <div class="justify-center group_17 view_6">
              <div class="flex-row">
                <div class="flex-row">
                  <img
                    src="../../assets/images/Collection.png"
                    class="image_9"
                  />
                  <span class="text_50">{{ v.collectCount }}</span>
                </div>
                <div class="flex-row group_20">
                  <img src="../../assets/images/share.png" class="image_11" />
                  <span class="text_52">{{ v.forwardCount }}</span>
                </div>
                <div class="flex-row group_20">
                  <img src="../../assets/images/comment.png" class="image_11" />
                  <span class="text_52">{{ v.commentCount }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="table">
      <div class="pages justify-end">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[3, 5, 10, 20]"
          :page-size="currentSize"
          layout="  prev, pager, next,  sizes, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["publishContent"],
  data() {
    return {
      showDetials: false,
      emptyImg: require("../../assets/images/emptyImg.png"),
      apiUrl: "",
      list_ZloHYvTf: [0, 0, 0],
      //翻页
      currentPage: 1,
      currentSize: 3,
      totalCount: 0,
      releasePageList: [],
    };
  },
  created() {
    this.apiUrl = window.api.apiurl;
    this.slicePage(1, 3);
  },
  mounted() {},
  methods: {
    //查看全部内容
    learnMore() {
      this.showDetials = true;
    },
    slicePage(currentPage, currentSize) {
      this.releasePageList = this.publishContent.slice(
        (currentPage - 1) * currentSize,
        currentPage * currentSize
      );
      this.totalCount = this.publishContent.length;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.currentSize = val;
      this.slicePage(this.currentPage, this.currentSize);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.slicePage(this.currentPage, this.currentSize);
    },
    //查看大图
    seeDetials(url) {
      window.open(`${this.apiUrl}${url}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.titleIsDel {
  max-width: 6rem;
  margin-right: 0.1rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
}
.imgs {
  width: 5.12rem;
}
.contentList {
  .group_11 {
    margin-left: 0.24rem;
    padding: 0.2rem 0;
    padding-left: 1.2rem;
    align-self: flex-start;
    border-bottom: 1px solid #dddddd;
    position: relative;
    .publish-content {
      display: flex;
      margin-left: -0.75rem;
    }
    .avaImg {
      border: 1px solid #ccc;
      margin-right: 0.15rem;
      width: 0.6rem;
      height: 0.6rem;
      border-radius: 50%;
    }
    .group_15 {
      align-self: flex-start;
      width: 4.07rem;
      .text_48 {
        margin-right: 0.1rem;
        // margin: 0.08rem 0 0.1rem;
        color: #999999;
        font-size: 0.14rem;
        font-family: Microsoft YaHei;
        // line-height: 0.12rem;
      }
      .image_7 {
        flex-shrink: 0;
        width: 0.3rem;
        height: 0.3rem;
      }
      .text_46 {
        // margin: 0.06rem 0 0.07rem 0.1rem;
        color: #555555;
        font-size: 0.14rem;
        font-family: Microsoft YaHei;
        // line-height: 0.17rem;
      }
      .text_18 {
        font-size: 18px !important;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
    }
    .view_5 {
      // margin-top: 0.26rem;
    }
    .group_17 {
      align-self: flex-start;
      // width: 2.21rem;
      .group_21 {
        margin: 0.04rem 0 0.03rem 0.31rem;
        .image_13 {
          flex-shrink: 0;
          width: 0.22rem;
          height: 0.18rem;
        }
        .text_54 {
          margin: 0.03rem 0 0.03rem 0.09rem;
          color: #999999;
          font-size: 0.16rem;
          font-family: Microsoft YaHei;
          line-height: 0.12rem;
        }
      }
      .group_20 {
        margin-left: 0.55rem;
        .image_11 {
          flex-shrink: 0;
          width: 0.15rem;
          height: 0.14rem;
        }
        .text_52 {
          margin: 0.06rem 0 0.04rem 0.1rem;
          color: #999999;
          font-size: 0.16rem;
          font-family: Microsoft YaHei;
          line-height: 0.12rem;
        }
      }
      .image_9 {
        flex-shrink: 0;
        width: 0.15rem;
        height: 0.14rem;
      }
      .text_50 {
        margin: 0.08rem 0 0.05rem 0.07rem;
        color: #999999;
        font-size: 0.16rem;
        font-family: Microsoft YaHei;
        line-height: 0.12rem;
      }
    }
    .view_6 {
      margin-top: 0.15rem;
    }
    .text_39 {
      margin-top: 0.22rem;
      align-self: flex-start;
      line-height: 0.17rem;
      i {
        cursor: pointer;
        font-size: 16px;
        color: #198cff;
      }
      span {
        color: #333333;
        font-size: 0.18rem;
        font-weight: 700;
        font-family: Microsoft YaHei;
      }
    }
    .list {
      margin-top: 0.14rem;
      .text-wrapper_2 {
        // padding: 0.07rem 0.2rem;
        // background-color: #fff;
        // border: 1px solid #2e9bff;
        // height: 0.3rem;
        margin-right: 0.16rem;
        .text_40 {
          color: #198cff;
          font-size: 0.14rem;
          font-family: Microsoft YaHei;
          line-height: 0.15rem;
        }
      }
    }
    .view_3 {
      padding: 0 0.02rem;
    }
    .view_3::before {
      content: "";
      display: inline-block;
      background: url("../../assets/images/tags.png") no-repeat;
      width: 21px;
      height: 21px;
      margin-right: 10px;
    }
    .group_13 {
      margin-top: 0.14rem;
      // padding-left: 0.75rem;
      .text_44 {
        color: #555555;
        font-size: 0.16rem;
        font-family: Microsoft YaHei;
        line-height: 0.28rem;
      }
      .text_45 {
        color: #555555;
        font-size: 0.16rem;
        font-family: Microsoft YaHei;
        line-height: 0.28rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/userDetail/release.vue